module.exports = __webpack_public_path__ + "static/media/cone.ca5eb2e7.png";